import './styles.scss';

import { Icon, Link } from '@ets-global/b2c-website-ui';
import classNames from 'classnames';
import React, { Fragment, useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { PrismicRichText } from '../../components/Base';
import NotFoundHandler from '../../components/NotFoundHandler';
import { LocalizedRedirect } from '../../components/Routing';
import { LEGAL_INFORMATIONS } from '../../graphql/queries';
import { useQuery, useRouter } from '../../hooks';
import { paths } from '../../paths';

const LegalInformation = () => {
  const { t } = useTranslation();
  const {
    lang,
    countryIso2: country,
    currentRoute: {
      params: { slug = null },
    },
    generatePrismicDocumentTypeOrCustomLinkPath,
  } = useRouter();
  const [isMenuActive, setIsMenuActive] = useState(false);
  const toggleMenu = () => setIsMenuActive(!isMenuActive);

  const {
    data: { legalInformations },
    loading,
  } = useQuery(LEGAL_INFORMATIONS, { variables: { lang, country } });

  useEffect(() => {
    setIsMenuActive(false);
  }, [slug]);

  let content = '';
  if (!loading) {
    const items = legalInformations.map((legalInformation) => ({
      ...legalInformation,
      url: paths.LEGAL_INFORMATION.replace(':slug?', legalInformation.slug),
    }));

    let currentLegalInformation = items[0];
    if (slug) {
      currentLegalInformation = items.find((item) => item.slug === slug);
    }

    if (!currentLegalInformation) return <NotFoundHandler />;

    if (currentLegalInformation.redirectLink?.slug) {
      return (
        <LocalizedRedirect
          status={301}
          to={generatePrismicDocumentTypeOrCustomLinkPath(currentLegalInformation.redirectLink)}
        />
      );
    }

    content = (
      <Fragment>
        <div className={'container container--padding'}>
          <div className="legal-information__menu-content-wrapper">
            <div className={`legal-information__menu ${isMenuActive ? 'legal-information__menu--active' : ''}`}>
              <button
                className="legal-information__menu-trigger"
                onClick={toggleMenu}
                aria-label={t('legal-information.menu')}
              >
                <Trans>legal-information.menu</Trans> <Icon name={'chevron'} aria-label="chevron-icon" role="img" />
              </button>
              <div className="legal-information__menu-list">
                {items.map(({ slug: currentSlug, title, url }, key) => (
                  <Link
                    key={key}
                    className={classNames(
                      'legal-information__menu-item',
                      ((currentSlug && currentSlug === slug) || (!slug && key === 0)) &&
                        'legal-information__menu-item--active'
                    )}
                    to={url}
                    aria-label={title}
                  >
                    {title}
                  </Link>
                ))}
              </div>
            </div>

            <div className="legal-information__content">
              <p className="legal-information__title">{currentLegalInformation.title}</p>
              <PrismicRichText richText={currentLegalInformation.content} />
            </div>
          </div>
        </div>
      </Fragment>
    );
  }

  return <main className="main container container--full legal-information">{content}</main>;
};

export default LegalInformation;
